export default () => {
  $('#requestDateModal').on('show.bs.modal', function (e) {
    if ($(this).attr('data-event-id')) {
      $('#InhouseContactForm select[name=contact_teamsize]').hide();
    } else {
      $('#InhouseContactForm select[name=contact_teamsize]').show();
    }
  });
};
